/*
 * LB Vendedora – Intercepta APENAS checkout, não add-to-cart
 */
(function () {
  'use strict';

  var ATTR_KEY = 'Vendedora';
  var MODAL_ID = 'lb-vendedora-modal';
  var _bypassing = false;

  function getCartAttr(cb) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      cb((cart.attributes && cart.attributes[ATTR_KEY]) || '');
    }).catch(function () { cb(''); });
  }

  function setCartAttr(value, cb) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Vendedora: value } })
    }).then(function () { if (cb) cb(); }).catch(function () { if (cb) cb(); });
  }

  // lista vem do cadastro (Conteúdo › Metaobjetos › Vendedoras), via window.lbVendedoras no layout
  function opcoesVendedoras() {
    var lista = window.lbVendedoras || [];
    return lista.map(function (v) {
      var val = String(v.valor).replace(/"/g, '&quot;');
      return '<option value="' + val + '">' + String(v.nome).replace(/</g, '&lt;') + '</option>';
    }).join('');
  }

  function buildModal() {
    if (document.getElementById(MODAL_ID)) return;
    var overlay = document.createElement('div');
    overlay.id = MODAL_ID;
    overlay.style.display = 'none';
    overlay.innerHTML =
      '<div style="position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:999999;display:flex;align-items:center;justify-content:center;">' +
        '<div style="background:#fff;border-radius:12px;padding:28px 24px;max-width:380px;width:90%;text-align:center;box-shadow:0 8px 32px rgba(0,0,0,.18);">' +
          '<p style="font-size:16px;font-weight:600;margin:0 0 6px;">👩‍💼 Qual vendedora te atende?</p>' +
          '<p style="font-size:13px;color:#666;margin:0 0 16px;">Selecione antes de finalizar a compra</p>' +
          '<select id="lb-vm-select" style="width:100%;padding:10px 14px;border:1.5px solid #ddd;border-radius:6px;font-size:14px;margin-bottom:12px;cursor:pointer;">' +
            '<option value="">— Selecione —</option>' +
            opcoesVendedoras() +
            '<option value="Não tenho vendedora">Não tenho vendedora</option>' +
          '</select>' +
          '<p id="lb-vm-err" style="display:none;color:#e74c3c;font-size:12px;margin:0 0 10px;">Selecione uma opção para continuar.</p>' +
          '<button id="lb-vm-ok" style="width:100%;padding:12px;background:#222;color:#fff;border:none;border-radius:6px;font-size:14px;font-weight:600;cursor:pointer;">Continuar para o checkout</button>' +
          '<button id="lb-vm-cancel" style="width:100%;padding:8px;background:none;border:none;font-size:13px;color:#888;cursor:pointer;margin-top:6px;">Voltar</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
  }

  function showModal(onConfirm) {
    buildModal();
    var modal = document.getElementById(MODAL_ID);
    var sel = document.getElementById('lb-vm-select');
    var err = document.getElementById('lb-vm-err');
    var ok = document.getElementById('lb-vm-ok');
    var cancel = document.getElementById('lb-vm-cancel');
    modal.style.display = '';
    sel.value = '';
    err.style.display = 'none';
    sel.style.borderColor = '#ddd';
    ok.textContent = 'Continuar para o checkout';
    ok.disabled = false;

    ok.onclick = function () {
      if (!sel.value) {
        err.style.display = 'block';
        sel.style.borderColor = '#e74c3c';
        return;
      }
      ok.textContent = 'Salvando...';
      ok.disabled = true;
      setCartAttr(sel.value, function () {
        modal.style.display = 'none';
        onConfirm();
      });
    };
    cancel.onclick = function () { modal.style.display = 'none'; };
    sel.onchange = function () {
      if (sel.value) { err.style.display = 'none'; sel.style.borderColor = '#ddd'; }
    };
  }

  function isCheckoutButton(el) {
    if (!el) return false;
    // Shopify Payment Button (COMPRE JÁ / Buy Now)
    if (el.closest('.shopify-payment-button__button') || el.closest('.shopify-payment-button')) return true;
    // Explicit checkout button
    if (el.name === 'checkout' || el.getAttribute('name') === 'checkout') return true;
    // Link to /checkout
    if (el.tagName === 'A' && el.href && el.href.indexOf('/checkout') !== -1) return true;
    return false;
  }

  function initInterceptors() {
    document.addEventListener('click', function (e) {
      if (_bypassing) return;
      var target = e.target;

      // 1) Shopify Payment Button (COMPRE JÁ)
      var spb = target.closest('.shopify-payment-button__button');
      if (spb) {
        e.preventDefault();
        e.stopImmediatePropagation();
        getCartAttr(function (val) {
          if (val) {
            _bypassing = true;
            spb.click();
            setTimeout(function () { _bypassing = false; }, 2000);
          } else {
            showModal(function () {
              _bypassing = true;
              spb.click();
              setTimeout(function () { _bypassing = false; }, 2000);
            });
          }
        });
        return;
      }

      // 2) Links diretos para /checkout
      var link = target.closest('a[href*="/checkout"]');
      if (link) {
        e.preventDefault();
        e.stopImmediatePropagation();
        getCartAttr(function (val) {
          if (val) {
            window.location.href = link.href;
          } else {
            showModal(function () { window.location.href = link.href; });
          }
        });
        return;
      }

      // NÃO intercepta mais nada — add-to-cart funciona normal
    }, true);

    // 3) Form submissions — SOMENTE botão checkout
    document.addEventListener('submit', function (e) {
      if (_bypassing) return;
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      var sel = (form.elements && form.elements['attributes[Vendedora]']) || form.querySelector('[name="attributes[Vendedora]"]');
      if (sel && sel.length !== undefined && !sel.tagName) sel = sel[0];
      if (sel && sel.value) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      getCartAttr(function (val) {
        if (val) {
          _bypassing = true;
          submitter.click();
          setTimeout(function () { _bypassing = false; }, 2000);
        } else if (sel) {
          sel.style.borderColor = '#e74c3c';
          sel.focus();
          var errEl = sel.parentElement.querySelector('.lb-vendedora-error');
          if (errEl) errEl.style.display = 'block';
          sel.onchange = function () {
            if (sel.value) {
              sel.style.borderColor = '#ddd';
              if (errEl) errEl.style.display = 'none';
            }
          };
        } else {
          showModal(function () {
            _bypassing = true;
            submitter.click();
            setTimeout(function () { _bypassing = false; }, 2000);
          });
        }
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInterceptors);
  } else {
    initInterceptors();
  }
})();
